import { BaseLayout } from "@components/general/base_layout";
import { Header } from "@components/general/header";
import { SemiCircle } from "@components/background/semi_circle";
import { AndroidDataEventMap } from "@declarations/event";
import { useBiometricStore } from "@stores/biometric.store";
import { useThemeStore } from "@stores/theme.store";
import { androidSetupBiometric } from "@utils/android";
import { useCallback, useEffect } from "react";
import { Outlet } from "react-router-dom";

export const HomePage = () => {
  const { updateStatusBiometric } = useBiometricStore((state) => state);
  // const { updateUnreadInbox } = useInboxStore((state) => state);
  const { setBottomNavigation } = useThemeStore((state) => state);

  // const onUnreadInboxListener = useCallback(
  //   (ev: MessageEvent<AndroidDataEventMap["on-unread-inbox"]>) => {
  //     updateUnreadInbox(ev.data);
  //   },
  //   [updateUnreadInbox]
  // );

  const onIsAvailableBiometricListener = useCallback(
    (ev: MessageEvent<AndroidDataEventMap["on-is-available-biometric"]>) => {
      localStorage.setItem("is-biometric", `${ev.data}`);
      const skip = localStorage.getItem("skip-biometric");
      if (skip !== "true") {
        localStorage.setItem("skip-biometric", "true");
        androidSetupBiometric("register");
      }
    },
    []
  );

  const onSetupBiometric = useCallback(
    (ev: MessageEvent<AndroidDataEventMap["on-setup-biometric"]>) => {
      localStorage.setItem("status-biometric", ev.data);
      updateStatusBiometric(ev.data === "register");
    },
    [updateStatusBiometric]
  );

  // const onTokenFirebaseListener = useCallback(
  //   (ev: MessageEvent<AndroidDataEventMap["on-token-firebase"]>) => {
  //     AccountService.updateTokenFirebase(ev.data);
  //   },
  //   []
  // );

  useEffect(() => {
    setBottomNavigation("home");
  }, [setBottomNavigation]);

  useEffect(() => {
    // window.addEventListener("on-unread-inbox", onUnreadInboxListener);
    window.addEventListener(
      "on-is-available-biometric",
      onIsAvailableBiometricListener
    );
    window.addEventListener("on-setup-biometric", onSetupBiometric);

    return () => {
      // window.removeEventListener("on-unread-inbox", onUnreadInboxListener);
      window.removeEventListener(
        "on-is-available-biometric",
        onIsAvailableBiometricListener
      );
      window.removeEventListener("on-setup-biometric", onSetupBiometric);
    };
  }, [onIsAvailableBiometricListener, onSetupBiometric]);

  // useEffect(() => {
  //   const updateTokenFirebase = setTimeout(() => androidTokenFirebase(), 1000);
  //   window.addEventListener("on-token-firebase", onTokenFirebaseListener);

  //   return () => {
  //     window.removeEventListener("on-token-firebase", onTokenFirebaseListener);
  //     clearTimeout(updateTokenFirebase);
  //   };
  // }, [onTokenFirebaseListener]);
  return (
    <>
      <BaseLayout>
        <SemiCircle />
        <Header />

        <Outlet />
      </BaseLayout>
    </>
  );
};
